<div
  class="tt-skeleton"
  role="status"
  aria-live="polite"
  [attr.aria-busy]="true"
  [attr.aria-label]="label"
>
  <ng-container [ngSwitch]="variant">
    <ng-container *ngSwitchCase="'cards'">
      <div class="tt-skeleton__cards">
        <div *ngFor="let _ of indexes(cards)" class="tt-skeleton__card tt-surface">
          <span class="tt-skel tt-skel--title"></span>
          <span class="tt-skel tt-skel--text-md"></span>
          <span class="tt-skel tt-skel--meta"></span>
          <div class="tt-skeleton__card-stats">
            <span class="tt-skel tt-skel--value"></span>
            <span class="tt-skel tt-skel--value"></span>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'chart'">
      <div class="tt-surface tt-surface--padded">
        <span class="tt-skel tt-skel--title"></span>
        <span class="tt-skel tt-skel--chart"></span>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'detail'">
      <div *ngIf="showToolbar" class="tt-skeleton__toolbar">
        <span class="tt-skel tt-skel--btn-sm"></span>
        <div class="tt-skeleton__toolbar-actions">
          <span *ngFor="let _ of indexesExact(toolbarIconActions)" class="tt-skel tt-skel--btn-icon"></span>
          <span *ngFor="let _ of indexesExact(toolbarActions)" class="tt-skel tt-skel--btn-sm"></span>
        </div>
      </div>
      <section class="tt-surface tt-surface--padded mb-6">
        <span class="tt-skel tt-skel--title"></span>
        <span class="tt-skel tt-skel--meta mb-4" style="display:block;margin-bottom:1rem"></span>
        <div class="tt-skeleton__detail-grid">
          <div *ngFor="let _ of indexes(detailFields)">
            <span class="tt-skel tt-skel--label"></span>
            <span class="tt-skel tt-skel--input"></span>
          </div>
        </div>
        <div *ngIf="toolbarActions > 0 && !showToolbar" class="tt-skeleton__toolbar mt-4" style="margin-bottom:0">
          <div class="tt-skeleton__toolbar-actions">
            <span *ngFor="let _ of indexesExact(toolbarActions)" class="tt-skel tt-skel--btn-sm"></span>
          </div>
        </div>
      </section>
      <div *ngIf="columns > 0" class="tt-skeleton__table tt-surface">
        <div class="tt-skeleton__table-head">
          <span *ngFor="let _ of indexes(columns)" class="tt-skel tt-skel--th"></span>
        </div>
        <div *ngFor="let _ of indexes(4)" class="tt-skeleton__table-row">
          <span *ngFor="let __ of indexes(columns)" class="tt-skel tt-skel--td"></span>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'calendar'">
      <div
        class="tt-skeleton__calendar"
        [style.--tt-skel-cal-cols]="columns"
      >
        <div *ngFor="let _ of indexes(columns)" class="tt-skeleton__calendar-day tt-surface">
          <div class="tt-skeleton__calendar-day-head">
            <span class="tt-skel tt-skel--meta"></span>
            <span class="tt-skel tt-skel--btn-icon"></span>
          </div>
          <div class="tt-skeleton__calendar-day-body">
            <span *ngFor="let __ of indexes(rows)" class="tt-skel tt-skel--input"></span>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'gantt'">
      <div class="tt-surface tt-skeleton__table">
        <div class="tt-skeleton__gantt-head">
          <span class="tt-skel tt-skel--th"></span>
          <span class="tt-skel tt-skel--th"></span>
          <span class="tt-skel tt-skel--th"></span>
        </div>
        <div *ngFor="let _ of indexes(rows)" class="tt-skeleton__gantt-row">
          <span class="tt-skel tt-skel--td"></span>
          <span class="tt-skel tt-skel--td"></span>
          <span class="tt-skel tt-skel--bar" style="width: 70%"></span>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'list'">
      <div *ngIf="showFilters" class="tt-skeleton__filters">
        <span
          *ngFor="let i of indexes(resolvedFilterCount)"
          class="tt-skel"
          [ngClass]="filterClass(i)"
        ></span>
      </div>
      <div class="tt-surface tt-skeleton__table">
        <div *ngFor="let _ of indexes(rows)" class="tt-skeleton__list-row">
          <span class="tt-skel tt-skel--td"></span>
          <span class="tt-skel tt-skel--meta"></span>
          <span *ngIf="toolbarIconActions > 0" class="tt-skel tt-skel--btn-icon" style="margin-left:auto"></span>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'page'">
      <div class="tt-skeleton__cards mb-6">
        <div *ngFor="let _ of indexes(4)" class="tt-skeleton__card tt-surface">
          <span class="tt-skel tt-skel--label"></span>
          <span class="tt-skel tt-skel--value"></span>
        </div>
      </div>
      <div class="tt-surface tt-surface--padded mb-6">
        <span class="tt-skel tt-skel--chart"></span>
      </div>
      <div *ngIf="showFilters" class="tt-skeleton__filters">
        <span
          *ngFor="let i of indexes(resolvedFilterCount)"
          class="tt-skel"
          [ngClass]="filterClass(i)"
        ></span>
      </div>
      <div class="tt-skeleton__table tt-surface">
        <div class="tt-skeleton__table-head">
          <span *ngFor="let _ of indexes(columns)" class="tt-skel tt-skel--th"></span>
        </div>
        <div *ngFor="let _ of indexes(rows)" class="tt-skeleton__table-row">
          <span *ngFor="let __ of indexes(columns)" class="tt-skel tt-skel--td"></span>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'sections'">
      <div *ngIf="showToolbar" class="tt-skeleton__toolbar mb-6">
        <div>
          <span class="tt-skel tt-skel--title" style="margin-bottom:0.35rem"></span>
          <span class="tt-skel tt-skel--meta"></span>
        </div>
      </div>
      <section *ngFor="let _ of indexes(sectionCount)" class="tt-skeleton__section">
        <div class="tt-skeleton__toolbar">
          <span class="tt-skel tt-skel--title" style="margin-bottom:0"></span>
          <div class="tt-skeleton__toolbar-actions">
            <span *ngFor="let __ of indexesExact(toolbarIconActions)" class="tt-skel tt-skel--btn-icon"></span>
            <span *ngFor="let __ of indexesExact(toolbarActions)" class="tt-skel tt-skel--btn-sm"></span>
          </div>
        </div>
        <div *ngIf="sectionFilterCount > 0" class="tt-skeleton__filters">
          <span
            *ngFor="let i of indexes(sectionFilterCount)"
            class="tt-skel"
            [ngClass]="filterClass(i)"
          ></span>
        </div>
        <div class="tt-skeleton__table tt-surface">
          <div class="tt-skeleton__table-head">
            <span *ngFor="let __ of indexes(sectionColumns)" class="tt-skel tt-skel--th"></span>
          </div>
          <div *ngFor="let __ of indexes(sectionRows)" class="tt-skeleton__table-row">
            <span *ngFor="let ___ of indexes(sectionColumns)" class="tt-skel tt-skel--td"></span>
          </div>
        </div>
      </section>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <div *ngIf="showToolbar" class="tt-skeleton__toolbar">
        <span class="tt-skel tt-skel--title" style="margin-bottom:0"></span>
        <div class="tt-skeleton__toolbar-actions">
          <span *ngFor="let _ of indexesExact(toolbarIconActions)" class="tt-skel tt-skel--btn-icon"></span>
          <span *ngFor="let _ of indexesExact(toolbarActions)" class="tt-skel tt-skel--btn-sm"></span>
        </div>
      </div>
      <div *ngIf="showFilters" class="tt-skeleton__filters">
        <span
          *ngFor="let i of indexes(resolvedFilterCount)"
          class="tt-skel"
          [ngClass]="filterClass(i)"
        ></span>
      </div>
      <div class="tt-skeleton__table tt-surface">
        <div class="tt-skeleton__table-head">
          <span *ngFor="let _ of indexes(columns)" class="tt-skel tt-skel--th"></span>
        </div>
        <div *ngFor="let _ of indexes(rows)" class="tt-skeleton__table-row">
          <span *ngFor="let __ of indexes(columns)" class="tt-skel tt-skel--td"></span>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
